import { mockBuyBonusApi, buyBonusApi } from './api/buyBonusApi'
import { BuyBonusService } from './service/buyBonusService'

const api = import.meta.env.MODE === 'development' ? mockBuyBonusApi : buyBonusApi
export const buyBonusService = new BuyBonusService(api)
